module.exports = __webpack_public_path__ + "static/media/ava.9419acc0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ava.jpeg
// module id = 350
// module chunks = 10